/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WaitlistStudentRow } from './WaitlistStudentRow';
import {
    WaitlistStudentRowFromJSON,
    WaitlistStudentRowFromJSONTyped,
    WaitlistStudentRowToJSON,
    WaitlistStudentRowToJSONTyped,
} from './WaitlistStudentRow';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WaitlistRow
 */
export interface WaitlistRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WaitlistRow
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof WaitlistRow
     */
    className: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WaitlistRow
     */
    waitlistCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<WaitlistStudentRow>}
     * @memberof WaitlistRow
     */
    students: Array<WaitlistStudentRow>;
}

/**
 * Check if a given object implements the WaitlistRow interface.
 */
export function instanceOfWaitlistRow(value: object): value is WaitlistRow {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('waitlistCount' in value) || value['waitlistCount'] === undefined) return false;
    if (!('students' in value) || value['students'] === undefined) return false;
    return true;
}

export function WaitlistRowFromJSON(json: any): WaitlistRow {
    return WaitlistRowFromJSONTyped(json, false);
}

export function WaitlistRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaitlistRow {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'waitlistCount': ApiUserTasksGetPageParameterFromJSON(json['waitlistCount']),
        'students': ((json['students'] as Array<any>).map(WaitlistStudentRowFromJSON)),
    };
}

export function WaitlistRowToJSON(json: any): WaitlistRow {
    return WaitlistRowToJSONTyped(json, false);
}

export function WaitlistRowToJSONTyped(value?: WaitlistRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'waitlistCount': ApiUserTasksGetPageParameterToJSON(value['waitlistCount']),
        'students': ((value['students'] as Array<any>).map(WaitlistStudentRowToJSON)),
    };
}

